module.exports = __webpack_public_path__ + "static/1-5ae1f9e7af426c02abf5199438df0b52.jpeg";